export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "caseConverter": {
    "title": "大小写转换器",
    "subtitle": "在 UPPER、lower、Title、camelCase、snake_case 等格式之间转换文本。",
    "privacy": "100% 本地处理",
    "inputLabel": "输入文本",
    "placeholder": "在此输入或粘贴文本...",
    "words": "字数",
    "chars": "字符数",
    "charsNoSpace": "不含空格",
    "lines": "行数",
    "emptyHint": "输入或粘贴文本以查看所有大小写转换结果",
    "caseUpper": "全大写",
    "caseLower": "全小写",
    "caseTitle": "首字母大写",
    "caseSentence": "句首大写",
    "caseCamel": "驼峰式",
    "casePascal": "帕斯卡式",
    "caseSnake": "蛇形命名",
    "caseKebab": "短横线命名",
    "caseConstant": "常量命名",
    "caseAlternating": "交替大小写",
    "caseReverse": "反转文本"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有文本处理均在您的浏览器本地完成。您的文本绝不会被上传到任何服务器。"
    },
    "guide": {
      "title": "如何使用大小写转换器",
      "description": "即时在大小写、小写、标题大小写、camelCase、snake_case 等之间转换文本。",
      "steps": [
        {
          "title": "粘贴文本",
          "description": "将任何文本复制粘贴到输入框中。该工具支持段落、代码片段、变量名和整个文档。"
        },
        {
          "title": "选择转换模式",
          "description": "从大写、小写、标题大小写、camelCase、PascalCase、snake_case、kebab-case 等中进行选择。"
        },
        {
          "title": "复制转换后的文本",
          "description": "输入时输出会实时更新。点击复制将转换后的文本保存到剪贴板以供即时使用。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "10 种以上大小写转换模式，包括编程用大小写",
        "输入时实时输出",
        "处理特殊字符和 Unicode 文本",
        "一键复制到剪贴板",
        "显示字符和字数统计",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的文本会被发送到服务器吗？",
          "answer": "不会。所有转换均在您的浏览器内完成。您的文本绝不会离开您的设备，因此适用于敏感的代码、姓名和文档。"
        },
        {
          "question": "camelCase 和 PascalCase 有什么区别？",
          "answer": "camelCase 以小写字母开头（例如 myVariableName），而 PascalCase 以大写字母开头（例如 MyClassName）。两者都会移除空格并将每个后续单词的首字母大写。"
        },
        {
          "question": "支持非英语文本吗？",
          "answer": "支持。转换器正确处理 Unicode 字符，包括带重音符号的字母、西里尔字母、中文、日文和阿拉伯文文本（在适用的情况下进行大小写转换）。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "Lorem Ipsum 生成器",
          "url": "/text/lorem-ipsum-generator",
          "description": "为设计、开发和内容原型生成占位文本。"
        },
        {
          "name": "Markdown 编辑器",
          "url": "/text/markdown-editor",
          "description": "使用语法高亮实时编写和预览 Markdown。"
        },
        {
          "name": "正则表达式测试器",
          "url": "/developer/regex-tester",
          "description": "实时测试正则表达式，支持匹配高亮显示。"
        }
      ]
    }
  }
};
